import React from 'react';

const SearchLazy = React.lazy(() => import('./Search'));

export default SearchLazy;
